import { render } from "./DirectorDetails.vue?vue&type=template&id=bdb95190&scoped=true"
import script from "./DirectorDetails.vue?vue&type=script&lang=js"
export * from "./DirectorDetails.vue?vue&type=script&lang=js"

import "./DirectorDetails.vue?vue&type=style&index=0&id=bdb95190&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb95190"]])

export default __exports__